<template>
  <div class="home_block_2">
    <div class="bookmark" :style="shu1Style" @click="toPersonDetail('赠言录')">
      <h2><ei-word :words="'万年神品妙自然'" :active="active0" style="color: #2358d4"
               :class="{'color_change':color0}"></ei-word>
     </h2>
      <h1><ei-word :words="'忠魂'" :active="active0" class="h1-word"
                     :class="{'color_change':color0}"></ei-word></h1>
    </div>
    <div class="bookmark" :style="shu2Style" @click="toPersonDetail('道德经录')">
      <h2><ei-word :words="'千秋翰墨寻根本'" :active="active1" style="color: #2358d4"
                   :class="{'color_change':color1}"></ei-word>
      </h2>
      <h1><ei-word :words="'树德'" :active="active1" class="h1-word"
                   :class="{'color_change':color1}"></ei-word></h1>
    </div>
    <div class="bookmark" :style="shu3Style" @click="toPersonDetail('真善美')">
      <h2><ei-word :words="'百岁涂鸦鉴与藏'" :active="active2" style="color: #2358d4"
                   :class="{'color_change':color2}"></ei-word>
      </h2>
      <h1><ei-word :words="'审美'" :active="active2" class="h1-word"
                   :class="{'color_change':color2}"></ei-word></h1>
    </div>
    <div class="bookmark" :style="shu4Style" @click="toPersonDetail('凌烟阁')">
      <h2><ei-word :words="'绝代双勾勤于练'" :active="active2" style="color: #2358d4"
                   :class="{'color_change':color2}"></ei-word>
      </h2>
      <h1><ei-word :words="'学艺'" :active="active2" class="h1-word"
                   :class="{'color_change':color2}"></ei-word></h1>
    </div>
    <div class="other">
      <h2  @click="toPersonDetail('诗文集')">《百字诗》 《百分谱》 《百韵千字文》</h2>
      <h1  @click="toPersonDetail('清鉴集')">凌烟阁 · 清鉴集</h1>
    </div>
  </div>
</template>

<script>
import { queryHomeBlockInHomeAction } from '@/api/reception/home-api'
import { isFailure } from '@/eiuov-utils/axios/response'
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
export default {
  name: 'EiHomeBlock2',
  data () {
    return {
      shu1Style: {},
      shu2Style: {},
      shu3Style: {},
      shu4Style: {},
      homeBlockList: [],
      active0: false,
      active1: false,
      active2: false,
      active3: false,
      color0: false,
      color1: false,
      color2: false,
      color3: false,
    }
  },
  created () {
    queryHomeBlockInHomeAction({ blockName: '首页模块2' }).then((res) => {
      if (isFailure(res)) return
      this.homeBlockList = res.data.list
      this.initHomeBlockList(this.homeBlockList)
    })
    this.fourAndEight();
  },
  methods: {
    fourAndEight() {
      setInterval(() => {
        setTimeout(() => {
          this.color3 = false
          this.active0 = true
          setTimeout(() => {
            this.active1 = true
            setTimeout(() => {
              this.active2 = true
              setTimeout(() => {
                this.active3 = true
                setTimeout(() => {
                  this.active0 = false
                  this.color0 = true
                  setTimeout(() => {
                    this.active1 = false
                    this.color0 = false
                    this.color1 = true
                    setTimeout(() => {
                      this.active2 = false
                      this.color1 = false
                      this.color2 = true
                      setTimeout(() => {
                        this.active3 = false
                        this.color2 = false
                        this.color3 = true
                      }, 500)
                    }, 500)
                  }, 500)
                }, 3000)
              }, 500)
            }, 500)
          }, 500)
        }, 500)
      }, 6500)
    },
    toPersonDetail (name) {
      this.$router.push({
        path: '/PersonDetail',
        query: { name: name },
      })
    },
    initHomeBlockList (list) {
      if (list.length === 0) return
      this.shu1Style = this.getBackGroundImage(list, '竖1')
      this.shu2Style = this.getBackGroundImage(list, '竖2')
      this.shu3Style = this.getBackGroundImage(list, '竖3')
      this.shu4Style = this.getBackGroundImage(list, '竖4')
    },
    getBackGroundImage (list, name) {
      if (list.length === 0) return {}
      for (let i = 0; i < list.length; i++) {
        if (list[i].blockName === name && list[i].picture !== null) {
          return {
            backgroundImage: 'url(' + list[i].picture.url + ')'
          }
        }
      }
      return {}
    },
    toWorkList (type) {
      this.$router.push({
        path: '/WorksList',
        query: { type: type }
      })
    },
  }
}
</script>

<style scoped lang="scss">
@use "sass:math";
$hb2_width: 1600px;

.home_block_2 {
  margin: 60px auto;
  width: $hb2_width;
  display: flex;
  justify-content: space-between;

  .bookmark {
    width: ($hb2_width - 120 - 150)/4;
    height: 780px;
    writing-mode: vertical-lr;
    display: flex;
    position: relative;
    color: #2358d4;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    transition: background-size 0.5s linear;
    cursor: pointer;

    &:hover {
      background-size: 110% 110%;
      transition: background-size 0.5s linear;
    }

    h2 {
      margin-left: 20px;
      margin-top: 3px;
      position: absolute;
      top: 20px;
      letter-spacing: 5px;
      font-weight: normal;
    }

    h1 {
      margin: auto;
      letter-spacing: 10px;
      font-weight: normal;
    }
  }

  .other {
    width: 150px;
    height: 600px;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;

    h1 {
      writing-mode: vertical-lr;
      letter-spacing: 5px;
    }

    h2 {
      margin-right: 10px;
      writing-mode: vertical-lr;
      letter-spacing: 5px;
    }
  }
}
// 大字标题（px 由 postcss 自动转 vw）
.h1-word {
  color: #e50205;
  font-size: 36px;
}

.color_change {
  animation: okkk 4s linear infinite;
  @keyframes okkk {
    0% {
      color: #67c23a
    }
    100% {
      color: #c30ce3
    }
  }
}
* img, span, a, div {
  user-select: none;
  -webkit-user-drag: none;
}
</style>
